import { IMenuCounter } from './../../interfaces/index';
import { IMenuItem } from '@/interfaces';
import { IMenu, IMenuCategory } from '@/interfaces';
import { State } from './../state';
import { IMenuState } from './state';
import { getStoreAccessors } from "typesafe-vuex";
import { indexOfCb } from '@/utils';

export const mutations =  {
    setMenu(state: IMenuState, payload: IMenu) {
        state.menu = payload;
    },
    setCategories(state: IMenuState, payload: IMenuCategory[]) {
        state.categories = payload;
    },
    setCategory(state: IMenuState, payload: IMenuCategory) {
        const idx = indexOfCb(state.categories, (v: IMenuCategory) => { 
            return v.id === payload.id;
         });
        
        if (idx >= 0) {
            state.categories[idx] = payload;
        } else {
            state.categories.push(payload);
        }
    },
    setMenuItems(state: IMenuState, payload: IMenuItem[]) {
        state.items = payload;
    },
    setMenuItem(state: IMenuState, payload: IMenuItem){
        const idx = indexOfCb(state.categories, (v: IMenuItem) => { 
            return v.id === payload.id;
         });
        
        if (idx >= 0) {
            state.items[idx] = payload;
        } else {
            state.items.push(payload);
        }
    },
    setMenuCounter(state: IMenuState, payload: IMenuCounter) {
        state.counter = payload;
    },
    removeMenuItem(state: IMenuState, id: number) {
        const idx = indexOfCb(state.items, (v: IMenuItem) => { 
            return v.id === id;
         });
        
        if (idx >= 0) {
            state.items.splice(idx, 1);
        }
    }
};

const {commit} = getStoreAccessors<IMenuState, State>('');

export const commitSetMenu = commit(mutations.setMenu);
export const commitSetMenuCategories = commit(mutations.setCategories);
export const commitSetMenuCategory = commit(mutations.setCategory);
export const commitSetMenuItems = commit(mutations.setMenuItems);
export const commitSetMenuItem = commit(mutations.setMenuItem);
export const commitSetMenuCounter = commit(mutations.setMenuCounter);
export const commitRemoveMenuItem = commit(mutations.removeMenuItem);